import { Component } from '@angular/core';

@Component({
  selector: 'uni-list-section',
  templateUrl: './uni-list-section.component.html',
  styleUrls: ['./uni-list-section.component.scss'],
})
export class UniListSectionComponent {}
